import {FeatureToggleConfig} from './src/types';

export const config = {
  serve_assets_from_origin: {
    defaultValue: false,
  },
  disable_urgency_triggers: {
    defaultValue: false,
    enableForLocales: ['hu_HU'],
  },
  enable_scroll_to_load_adp_recos: {
    defaultValue: false,
  },
  enable_semantic_search: {
    defaultValue: false,
  },
  force_sso_methods: {
    defaultValue: false,
  },
  enable_abort_be_requests: {
    defaultValue: false,
  },
  enable_cs_chatbot: {
    defaultValue: false,
  },
  crm_coupons: {
    defaultValue: false,
  },
  coupons: {
    defaultValue: false,
  },
  mov_coupons: {
    defaultValue: false,
  },
  ab_test_setup_enabled: {
    defaultValue: true,
  },
  desktop_legacy_memory_optimizations: {
    defaultValue: false,
  },
  console_log_legacy_state_sync: {
    defaultValue: false,
  },
  attribute_filters_slugified_ids: {
    defaultValue: false,
  },
  show_old_help_center: {
    defaultValue: false,
  },
  show_basket_login_hint: {
    defaultValue: false,
    experiment: [
      {
        name: 'ab_log_basket_d',
        mapping: {
          'lgbd-c': 'control-desktop',
          'lgbd-1': 'desktop_login_hint_basket',
        },
      },
      {
        name: 'ab_log_basket_m',
        mapping: {
          'lgbm-c': 'control-mobile',
          'lgbm-1': 'mobile_login_hint_basket',
        },
      },
    ],
  },
  show_inline_size_quick_view: {
    defaultValue: false,
    experiment: [
      {
        name: 'ab_om_size_selection_m',
        mapping: {
          'omsm-c': 'inline_size_selection_quick_view_mobile_control',
          'omsm-1': 'inline_size_selection_quick_view_mobile_variant',
        },
      },
    ],
  },
  show_basket_delivery_as_days: {
    defaultValue: false,
    experiment: [
      {
        name: 'ab_bsk_delivery_dates_display_m',
        mapping: {
          'ddm-c': 'show_basket_delivery_as_days_control_m',
          'ddm-1': 'show_basket_delivery_as_days_variant_m',
        },
      },
      {
        name: 'ab_bsk_delivery_dates_display_d',
        mapping: {
          'ddd-c': 'show_basket_delivery_as_days_control_d',
          'ddd-1': 'show_basket_delivery_as_days_variant_d',
        },
      },
    ],
  },
  show_campaign_cards_login_hint: {
    defaultValue: false,
    experiment: [
      {
        name: 'ab_log_ccards_m',
        mapping: {
          'lgcm-c': 'control-mobile',
          'lgcm-1': 'mobile_login_hint_campaign_card',
        },
      },
      {
        name: 'ab_log_ccards_d',
        mapping: {
          'lgcd-c': 'control-desktop',
          'lgcd-1': 'desktop_login_hint_campaign_card',
        },
      },
    ],
  },
  basket_mweb_fomo_hint: {
    defaultValue: false,
    experiment: [
      {
        name: 'ab_fols_m',
        mapping: {
          'folm-c': 'control-mweb',
          'folm-1': 'basket_mweb_fomo_hint',
        },
      },
    ],
  },

  basket_mweb_campaign_fomo_hint: {
    defaultValue: false,
    experiment: [
      {
        name: 'ab_fosh_m',
        mapping: {
          'fosm-c': 'control-mweb-campaign',
          'fosm-1': 'basket-mweb-campaign-fomo-hint',
        },
      },
    ],
  },
  ab_price_display_overhaul_v2: {
    defaultValue: false,
  },

  user_auth_captcha: {
    defaultValue: false,
  },
  show_international_popup: {
    defaultValue: false,
  },
  track_origin_click: {
    defaultValue: true,
  },
  track_ga4: {
    defaultValue: true,
  },
  track_ga3: {
    defaultValue: false,
  },
  language_switch: {
    defaultValue: false,
    enableForLocales: ['nl_BE', 'fr_BE', 'de_CH', 'fr_CH', 'de_DE', 'en_DE'],
  },
  complementary_recommendation: {
    defaultValue: false,
  },
  tadarida_session_sharing: {
    defaultValue: false,
    enableForLocales: [
      'en_ZZ',
      'es_ZZ',
      'de_DE',
      'en_DE',
      'de_CH',
      'fr_CH',
      'it_CH',
      'nl_BE',
      'fr_BE',
      'lv_LV',
      'ru_LV',
      'et_EE',
      'ru_EE',
    ],
  },
  datadog_session_replay: {
    defaultValue: false,
  },
  big_bang_launch_teaser_page: {
    defaultValue: false,
  },
  show_woohoo_campaign_LV_LT_EE: {
    defaultValue: false,
  },
  show_woohoo_campaign_FI_BG: {
    defaultValue: false,
  },
  show_woohoo_campaign_HU: {
    defaultValue: false,
  },
  show_woohoo_campaign_DK_SE: {
    defaultValue: false,
  },
  show_woohoo_campaign_RO: {
    defaultValue: false,
  },
  show_woohoo_campaign_NO: {
    defaultValue: false,
    timeFrame: {
      start: {
        time: '2023-04-17T11:00:00+02:00',
        value: true,
      },
      end: {
        time: '2023-04-23T23:59:59+02:00',
        value: false,
      },
    },
  },
  show_woohoo_campaign_BE_NL: {
    defaultValue: false,
    timeFrame: {
      start: {
        time: '2023-04-17T11:00:00+02:00',
        value: true,
      },
      end: {
        time: '2023-04-30T23:59:59+02:00',
        value: false,
      },
    },
    enableForLocales: ['nl_NL', 'nl_BE', 'fr_BE'],
  },
  show_woohoo_campaign_DE_AT_CH: {
    defaultValue: false,
    timeFrame: {
      start: {
        time: '2023-04-21T11:00:00+02:00',
        value: true,
      },
      end: {
        time: '2023-05-07T23:59:59+02:00',
        value: false,
      },
    },
    enableForLocales: ['de_DE', 'en_DE', 'de_AT', 'de_CH', 'fr_CH'],
  },
  show_woohoo_campaign_ES_PT: {
    defaultValue: false,
    timeFrame: {
      start: {
        time: '2023-05-02T11:00:00+02:00',
        value: true,
      },
      end: {
        time: '2023-05-14T23:59:59+02:00',
        value: false,
      },
    },
    enableForLocales: ['es_ES', 'pt_PT'],
  },
  show_woohoo_campaign_CZ: {
    defaultValue: false,
    timeFrame: {
      start: {
        time: '2023-05-15T11:00:00+02:00',
        value: true,
      },
      end: {
        time: '2023-05-28T23:59:59+02:00',
        value: false,
      },
    },
    enableForLocales: ['cs_CZ'],
  },
  show_woohoo_campaign_CY_GR: {
    defaultValue: false,
    timeFrame: {
      start: {
        time: '2023-07-10T11:00:00+02:00',
        value: true,
      },
      end: {
        time: '2023-07-23T23:59:59+02:00',
        value: false,
      },
    },
    enableForLocales: ['el_CY', 'el_GR'],
  },
  basket_v2_express_checkout: {
    defaultValue: false,
    experiment: [
      {
        name: 'ab_paypal_express_d',
        mapping: {
          'pped-c': 'control-desktop',
          'pped-1': 'pp-express-enabled-desktop',
        },
      },
      {
        name: 'ab_paypal_express_m',
        mapping: {
          'ppem-c': 'control-mweb',
          'ppem-1': 'pp-express-enabled-mweb',
        },
      },
    ],
  },
  enable_guest_checkout: {
    defaultValue: false,
    enableForLocales: ['fr_FR', 'fi_FI', 'de_DE', 'en_DE'],
  },
  web_mobile_push_notifications: {
    defaultValue: false,
  },
  size_reminder_push_notifications: {
    defaultValue: false,
  },
  minimal_order_value: {
    defaultValue: false,
  },
  return_costs_naa: {
    defaultValue: false,
  },
  adp_reviews: {
    defaultValue: false,
    experiment: {
      name: 'adp_reviews',
      mapping: {},
    },
  },
  diverse_gender: {
    defaultValue: false,
  },
  neutral_gender: {
    defaultValue: false,
  },
  adp_ratings_desk: {
    defaultValue: 'control',
    experiment: {
      name: 'adp_ratings_desk',
      mapping: {
        control: 'control',
        var_1: 'var_1',
      },
    },
  },
  disable_drops_entry: {
    defaultValue: false,
  },
  teaser_entity: {
    defaultValue: false,
  },

  disableDesktopHeaderFlyouts: {
    defaultValue: false,
  },
  unit_test_feature_dont_delete: {
    defaultValue: false,
  },

  bas_homepage_campaign_takeover_edited: {
    defaultValue: false,
  },
  bas_homepage_campaign_takeover_guido_maria: {
    defaultValue: false,
    timeFrame: {
      start: {
        time: '2023-05-30T10:00:00+02:00',
        value: true,
      },
      end: {
        time: '2023-05-31T10:00:00+02:00',
        value: false,
      },
    },
    enableForLocales: [
      'de_DE',
      'en_DE',
      'de_AT',
      'de_CH',
      'de_CH',
      'fr_CH',
      'it_CH',
      'pl_PL',
      'hu_HU',
      'ro_RO',
      'cs_CZ',
      'bg_BG',
      'et_EE',
      'ru_EE',
      'lv_LV',
      'ru_LV',
      'sl_SI',
      'hr_HR',
      'sk_SK',
      'lt_LT',
      'fi_FI',
      'sv_SE',
      'da_DK',
      'es_ES',
      'it_IT',
      'pt_PT',
      'el_GR',
      'nl_NL',
      'nl_BE',
      'fr_BE',
      'fr_FR',
    ],
  },
  bas_homepage_campaign_takeover_lascana: {
    defaultValue: false,
    timeFrame: {
      start: {
        time: '2023-08-28T10:00:00+02:00',
        value: true,
      },
      end: {
        time: '2023-08-31T10:00:00+02:00',
        value: false,
      },
    },
    enableForLocales: [
      'pl_PL',
      'cs_CZ',
      'ro_RO',
      'sl_SI',
      'lv_LV',
      'ru_LV',
      'lt_LT',
      'nl_BE',
      'fr_BE',
      'fr_FR',
      'fi_FI',
      'da_DK',
      'sv_SE',
      'it_IT',
      'es_ES',
      'pt_PT',
    ],
  },
  bas_homepage_campaign_takeover_lascana_2: {
    defaultValue: false,
    timeFrame: {
      start: {
        time: '2023-08-28T10:00:00+02:00',
        value: true,
      },
      end: {
        time: '2023-09-01T10:00:00+02:00',
        value: false,
      },
    },
    enableForLocales: ['de_CH', 'fr_CH', 'it_CH', 'sk_SK', 'hu_HU', 'bg_BG'],
  },
  bas_homepage_campaign_takeover_lascana_3: {
    defaultValue: false,
    timeFrame: {
      start: {
        time: '2023-08-30T00:10:00+02:00',
        value: true,
      },
      end: {
        time: '2023-09-01T10:00:00+02:00',
        value: false,
      },
    },
    enableForLocales: ['de_DE', 'en_DE', 'de_AT', 'nl_NL'],
  },
  show_hero_notification: {
    defaultValue: false,
  },
  new_banner_framework: {
    defaultValue: false,
  },
  bas_homepage_campaign_puma: {
    defaultValue: false,
    timeFrame: {
      start: {
        time: '2023-12-01T10:00:00+02:00',
        value: true,
      },
      end: {
        time: '2023-12-01T16:59:59+02:00',
        value: false,
      },
    },
    enableForLocales: ['de_DE', 'en_DE', 'de_AT', 'de_CH', 'fr_CH', 'it_CH'],
  },
  bas_homepage_campaign_hugo: {
    defaultValue: false,
    timeFrame: {
      start: {
        time: '2024-03-11T10:00:00+01:00',
        value: true,
      },
      end: {
        time: '2024-03-13T10:00:00+01:00',
        value: false,
      },
    },
    enableForLocales: ['de_DE', 'en_DE', 'de_AT', 'de_CH', 'fr_CH', 'it_CH'],
  },

  disable_sustainability_page: {
    defaultValue: false,
    enableForLocales: ['nl_NL'],
  },
  show_outlet_link: {
    defaultValue: false,
    enableForLocales: [
      'de_DE',
      'en_DE',
      'de_AT',
      'cs_CZ',
      'ro_RO',
      'hu_HU',
      'sl_SI',
      'sk_SK',
      'hr_HR',
      'pl_PL',
      'bg_BG',
      'el_GR',
      'lt_LT',
      'lv_LV',
      'ru_LV',
      'de_CH',
      'en_CH',
      'fr_CH',
      'it_CH',
      'nl_NL',
      'en_NL',
      'pt_PT',
    ],
  },
  show_woohoo_campaign_IT: {
    defaultValue: false,
    timeFrame: {
      start: {time: '2023-03-20T11:00:00+02:00', value: true},
      end: {time: '2023-04-02T23:59:59+02:00', value: false},
    },
    enableForLocales: ['it_IT'],
  },
  show_woohoo_campaign_SI: {
    defaultValue: false,
    timeFrame: {
      start: {time: '2023-06-05T11:00:00+02:00', value: true},
      end: {time: '2023-06-18T23:59:59+02:00', value: false},
    },
    enableForLocales: ['sl_SI'],
  },
  show_woohoo_campaign_PL: {
    defaultValue: false,
    timeFrame: {
      start: {time: '2023-06-12T11:00:00+02:00', value: true},
      end: {time: '2023-06-25T23:59:59+02:00', value: false},
    },
    enableForLocales: ['pl_PL'],
  },
  show_woohoo_campaign_HR: {
    defaultValue: false,
    timeFrame: {
      start: {time: '2023-09-04T11:00:00+02:00', value: true},
      end: {time: '2023-09-17T23:59:59+02:00', value: false},
    },
    enableForLocales: ['hr_HR'],
  },
  a2w_action_login: {
    defaultValue: false,
    experiment: [
      {
        name: 'ab_log_a2w_d',
        mapping: {
          'lgwd-c': 'control-desktop',
          'lgwd-1': 'a2w-action-login-hint-desktop',
        },
      },
      {
        name: 'ab_log_a2w_m',
        mapping: {
          'lgwm-c': 'control-mweb',
          'lgwm-1': 'a2w-action-login-hint-mweb',
        },
      },
    ],
  },
  personal_filters_feature: {
    defaultValue: false,
  },
  desktop_adp_ratings: {
    defaultValue: false,
    experiment: {
      name: 'ab_adp_bvd',
      mapping: {
        'bv-c': 'control',
        'bv-1': 'should-display-reviews-on-buybox-and-product-details',
        'bv-2': 'should-display-reviews-only-on-product-details',
      },
    },
  },
  ab_img_m: {
    defaultValue: 'img-c',
    experiment: {
      name: 'ab_img_m',
      mapping: {
        'img-c': 'control',
        'img-1': 'reduced-image-gallery-height',
      },
    },
  },
  aa_test_disco_mweb: {
    defaultValue: false,
    experiment: {
      name: 'ab_atc_m',
      mapping: {
        'tcm-c': 'control',
        'tcm-1': 'variant-1',
      },
    },
  },
  ab_adp_bv3: {
    defaultValue: false,
    experiment: {
      name: 'ab_adp_bv3',
      mapping: {
        'rvm-c': 'rvm-c',
        'rvm-1': 'rvm-1',
        'rvm-2': 'rvm-2',
      },
    },
  },
  ay_outlet_bas_banner: {
    defaultValue: false,
    experiment: [
      {
        name: 'ab_oba_d',
        mapping: {
          'obd-c': 'obd-c',
          'obd-1': 'hide-d-ayo-bas-banner',
        },
      },
      {
        name: 'ab_oba_m',
        mapping: {
          'obm-c': 'obm-c',
          'obm-1': 'hide-m-ayo-bas-banner',
        },
      },
    ],
  },
  search_result_questionnaire: {
    defaultValue: false,
  },
  search_internationalization: {
    defaultValue: false,
    experiment: {
      name: 'ab_search_new_w',
      mapping: {
        'nss-c': 'control',
        'nss-1': 'new_search',
      },
    },
  },
  enable_category_landing_page_test: {
    defaultValue: false,
    experiment: [
      {
        name: 'ab_test_setup_landingpage',
        mapping: {
          'tslp-c': 'mobile-control',
          'tslp-1': 'mobile-variant-1',
        },
      },
      {
        name: 'ab_test_setup_landingpage_d',
        mapping: {
          'tslpd-c': 'desktop-control',
          'tslpd-1': 'desktop-variant-1',
        },
      },
    ],
  },
  enable_a2b_test: {
    defaultValue: false,
    experiment: [
      {
        name: 'ab_test_setup_a2b',
        mapping: {
          'tsa2b-c': 'mobile-control',
          'tsa2b-1': 'mobile-variant-1',
        },
      },
      {
        name: 'ab_test_setup_a2b_d',
        mapping: {
          'tsa2bd-c': 'desktop-control',
          'tsa2bd-1': 'desktop-variant-1',
        },
      },
    ],
  },
  enable_adp_reco_test: {
    defaultValue: false,
    experiment: [
      {
        name: 'ab_test_setup_reco',
        mapping: {
          'tspr-c': 'mobile-control',
          'tspr-1': 'mobile-variant-1',
        },
      },
      {
        name: 'ab_test_setup_reco_d',
        mapping: {
          'tsprd-c': 'desktop-control',
          'tsprd-1': 'desktop-variant-1',
        },
      },
    ],
  },
  rokt_advertisement: {
    defaultValue: false,
  },
  sovendus_advertisement: {
    defaultValue: false,
  },
  desk_interactive_category_tile: {
    defaultValue: false,
  },
  adp_mov: {
    defaultValue: false,
  },
  mov_upselling_recos: {
    defaultValue: false,
    experiment: [
      {
        name: 'ab_ba_mov_upselling_m',
        mapping: {
          'mvum-c': 'control-m',
          'mvum-1': 'variant-m-1',
        },
      },
      {
        name: 'ab_ba_mov_upselling_d',
        mapping: {
          'mvud-c': 'control-d',
          'mvud-1': 'variant-d-1',
        },
      },
    ],
  },
  creative_campaign: {
    defaultValue: false,
    timeFrame: {
      start: {time: '2024-04-30T09:00:00+02:00', value: true},
      end: {time: '2024-05-05T23:59:59+02:00', value: false},
    },
  },
  ay_anniversary_campaign_PT: {
    defaultValue: false,
    timeFrame: {
      start: {time: '2024-04-15T10:00:00+02:00', value: true},
      end: {time: '2024-05-12T23:59:59+01:00', value: false},
    },
    enableForLocales: ['pt_PT'],
  },
  ay_anniversary_campaign_DE_AT_CH_NL_BE_PL_CZ_SK_HU_SI_HR_FR_DK_SE_IT_ES_NO_LU:
    {
      defaultValue: false,
      timeFrame: {
        start: {time: '2024-04-15T10:00:00+02:00', value: true},
        end: {time: '2024-05-12T23:59:59+02:00', value: false},
      },
      enableForLocales: [
        'de_DE',
        'en_DE',
        'de_AT',
        'de_CH',
        'fr_CH',
        'it_CH',
        'nl_NL',
        'fr_BE',
        'nl_BE',
        'pl_PL',
        'cs_CZ',
        'sk_SK',
        'hu_HU',
        'sl_SI',
        'hr_HR',
        'fr_FR',
        'da_DK',
        'sv_SE',
        'it_IT',
        'es_ES',
        'fr_LU',
        'en_ZZ',
        'es_ZZ',
      ],
    },
  ay_anniversary_campaign_RO_LT_LV_EE_BG_FI_GR_CY: {
    defaultValue: false,
    timeFrame: {
      start: {time: '2024-04-15T10:00:00+02:00', value: true},
      end: {time: '2024-05-13T23:59:59+03:00', value: false},
    },
    enableForLocales: [
      'ro_RO',
      'lt_LT',
      'lv_LV',
      'ru_LV',
      'et_EE',
      'ru_EE',
      'bg_BG',
      'fi_FI',
      'el_GR',
      'el_CY',
    ],
  },
  enable_coupon_wallet: {
    defaultValue: false,
  },
  enable_app_welcome_coupon_banner: {
    defaultValue: false,
  },
  enable_user_email_editing: {
    defaultValue: false,
  },
  adp_delivery_estimation: {
    defaultValue: false,
  },
  enable_desktop_outfit_slider: {
    defaultValue: false,
  },
  high_tier_coupons: {
    defaultValue: false,
  },
  ff_coins_rollout: {
    defaultValue: false,
    experiment: {
      name: 'ff_coins_rollout',
      mapping: {
        'coi-c': 'disabled',
        'coi-1': 'enabled',
      },
    },
  },
  cp_load_more_button: {
    defaultValue: false,
  },
  ab_klarna_express: {
    defaultValue: false,
    experiment: [
      {
        name: 'ab_klarna_express_m',
        mapping: {
          'ake-c': 'disabled mweb',
          'ake-1': 'enabled mweb',
        },
      },
      {
        name: 'ab_klarna_express_d',
        mapping: {
          'ake-c': 'disabled desktop',
          'ake-1': 'enabled desktop',
        },
      },
    ],
  },
  price_display_overhaul: {
    defaultValue: false,
  },
  ff_legacy_price_color_display: {
    defaultValue: false,
  },
  secondary_price_label_BG: {
    defaultValue: false,
    timeFrame: {
      start: {time: '2025-08-01T00:00:00+02:00', value: true},
      end: {time: '2026-08-08T00:00:00+01:00', value: false},
    },
    enableForLocales: ['bg_BG'],
  },
  sportswear_page: {
    defaultValue: false,
  },
  enable_sponsored_product_tile_unsampled_logging: {
    defaultValue: false,
  },
  ab_missions_rollout: {
    defaultValue: false,
    experiment: {
      name: 'ab_missions_rollout',
      mapping: {
        'mr-c': 'disabled',
        'mr-1': 'enabled',
      },
    },
  },
  ab_adp_new_tab: {
    defaultValue: false,
    experiment: {
      name: 'ab_adp_new_tab',
      mapping: {
        'aant-c': 'disabled',
        'aant-1': 'enabled',
      },
    },
  },
  ff_missions_v2_rollout: {
    defaultValue: false,
    experiment: {
      name: 'ab_missions_claiming',
      mapping: {
        'mic-c': 'mic-c',
        'mic-1': 'mic-1',
        'mic-2': 'mic-2',
      },
    },
  },
  require_bic_field: {
    defaultValue: false,
  },
} as const satisfies Record<string, FeatureToggleConfig>;
